import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Aviso permanente sutil en sidebar (modo portal).
 */
function PortalDisclaimerRail({ className = '' }) {
  const { t } = useTranslation()
  return (
    <div
      className={`udv-portal-disclaimer-rail${className ? ` ${className}` : ''}`}
      role="note"
      title={t('portal.disclaimerBody')}
    >
      {t('portal.disclaimerShort')}
    </div>
  )
}

export default PortalDisclaimerRail
